module.exports = __webpack_public_path__ + "img/index1.77e1eca5.png";